module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/train-list/train-list.component.scss
// module id = 1219
// module chunks = 0